import script from "./imageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./imageComponent.vue?vue&type=script&setup=true&lang=js"

import "./imageComponent.vue?vue&type=style&index=0&id=5fc526c0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b3655c94b52f2edce08bd59b38cc948d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc526c0"]])

export default __exports__